<template>
  <div class="main">

    <!-- ToolBar -->
    <div class="mb-4 pb-3">
      <v-toolbar fixed light dense color="white">
        <v-btn active-class icon light to="/">
          <v-icon color="grey darken-2">arrow_back</v-icon>
        </v-btn>
        <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
        <!-- Add an avatar image here to the left of the TK name -->
        <v-toolbar-title class="tklogo">T K</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn icon><v-icon>search</v-icon></v-btn> -->
        <!-- <v-btn active-class icon v-on:click="goHome"><v-icon>fa fa-home</v-icon></v-btn> -->
        <v-btn active-class icon to="/tkbios">
          <v-tooltip color="blue" nudge-left="40px" bottom>
            <v-icon slot="activator" color="black" dark>fas fa-cat</v-icon>
            <span>Back to All TK Cat Bios</span>
          </v-tooltip>
        </v-btn>

        <v-btn active-class icon to="/">
          <v-tooltip color="blue" nudge-left="40px" bottom>
            <v-icon slot="activator" color="black" dark>fa fa-home</v-icon>
            <span>Back to Home</span>
          </v-tooltip>
        </v-btn>

        <v-btn active-class icon flat round href="https://www.facebook.com/timmyskittys1" target="_blank">
          <v-tooltip color="blue" nudge-left="40px" bottom>
            <v-icon slot="activator" color="black" dark>fab fa-facebook-square</v-icon>
            <span>Visit Us on Facebook</span>
          </v-tooltip>
        </v-btn>

      </v-toolbar>
    </div>

    <v-container fluid class="mainlogo">

      <v-layout column wrap align-center>
        <!--
        <v-flex xs12 sm8>
          <v-card flat>
            <h2 class="tkheading">About Timmy's Kitty's</h2>
          </v-card>
        </v-flex>
        -->
        <v-flex xs12 sm8>
          <v-card flat>
            <p style="font-size: 1.2rem;">
              <span class="mainheading">Timmy's Kitty's About Page</span>
            </p>
          </v-card>
        </v-flex>

      </v-layout>

      <v-layout column wrap align-left>

        <!-- About Timmy's Kitty's -->
        <v-flex xs12 sm8>
          <v-card flat class="v-card-border mb-2">
            <!--
            <span style="font-size: 1.3rem;">
              <v-icon class="profilebio pl-2 pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
              About Timmy's Kitty's:
            </span>
            -->
            <p class="pl-3 pb-1">
              <!-- <v-icon class="profilebio pl-2 pb-1" size=".8rem" color="blue">fas fa-square</v-icon> -->
              <p class="pl-2">
              <span class="tkheading">Timmy's Kitty's</span> is still in development. Much more to come. Like us on <a href="https://www.facebook.com/timmyskittys1" target="_blank" style="text-decoration: none; color: blue;">FaceBook</a> for the latest pictures and videos. We'll send out updates for TK on FB. Thanks for visiting, we appreciate your time. So, now ...
              <br><br>
              <!-- <v-icon class="profilebio pl-2 pb-1" size=".8rem" color="blue">fas fa-square</v-icon> -->
              What is the purpose of <span class="tkheading">Timmy's Kitty's</span>? Below I list 3 purposes along with details for each:
              <br><br>
              <span class="firstletter">F</span>irst, some of the cats on this site (and many more to come) are available for possible adoption. They have been either rescued, or born at our location from the rescues. After visiting Timmy's Kitty's (both this site and TK FaceBook) we hope the experience will allow someone to peer into the life, begin a connection, and hopefully spark a bond with a potential new family member (the animal adoptee). 
              <br><br>
              At the same time, this site can serve as a Bio page for your own personal pet or adoptable animal(s). You write the bio details (questions and answers), upload the pictures, videos, and write the stories.
              Then your animal(s) will have it's own easily accessible and mobile friendly Bio Page with it's own URL, <span style="color: blue;">www.timmyskittys.com/my_animal_name</span>.
              You can also connect your animals Bio page from or to other web sites, including your own FaceBook page. What do you think? Email and let us know <a href="mailto:tkwebdev23@gmail.com" style="text-decoration: none; color: blue;">tkwebdev23@gmail.com</a> .
              <br><br>
              One may ask, "How can a web site make a true connection, a lasting bond with an animal without first meeting that animal in person?"
              Well, I'm not sure a heartfelt connection or solid bond can be made via technology (debatable, sure, and for some the
              connection/bond my be real for them). So, what would be the best and most impactful way, using the internet, to make some type of
              meaningful introduction where the visitor is left excitedly saying, "Yes, I feel this may be the one, I would like to see and know more." ?
              <br><br>
              Answer: <span class="tkheading">Timmy's Kitty's</span> (Both this site and Timmy's Kitty's <a href="https://www.facebook.com/timmyskittys1" target="_blank" style="text-decoration: none; color: blue;">FaceBook</a>). Through the extended animal bio information, full picture gallery, detailed stories (with pictures), insightful videos,
              and web site extensibility through its component framework design (for future capabilities). Let us get down and dirty and spill the beans, tell and show all, paint the picture of
              who the animal is through the use of pictures, videos, and stories, and whatever else is made available via the web to aid in the digital connection and bond.
              If the someone is ready to meet the animal after their experience on Timmy's Kitty's, the next step would be to start to create that heartfelt connection and solid
              bond by visiting the animal in person (a home visit, an in person meet and greet, is always required). Because when it comes to adoption, for me it is about adopting to the right
              home and family, the best fit for the animal, as well as, the family or person adopting.
              <!-- I believe Timmy's Kitty's can ... and provide kitty, doggie, or whatever animal one may be looking to adopt. -->
              <!--
              <br>
              <br>
              Most adoption sites, do a great job and I'm very thankful for each and every one of them. And, from my experience, posts for an animal will have
              the basic information on the animal (name, age, type, quick intro), a few pictures, and maybe a video or two (I could be totally off here, but
              just my own exprience.). I understand that the sites provide a platform for their customers to create the full details/videos/pictures on the
              given animal.
              <br>
              Hopefully others will want to create animial bios for their animails or adoptable animal. You write the bio, questions and all, you upload your pictures, videos, and write your own stores. Then your animals will have it's own www.timmyskittys.com/my_animal_name Bio Page that you fully control, access and all. What do you think? Email and let us know tkwebdev23@gmail.com .
              -->
              </p>

              <br>
              <p class="pl-2"><span class="firstletter">S</span>econd purpose is for web development using Vue.js (a JavaScript Framework) and Vuetify (a CSS Framework). My IT experience started way back in the late 80's (Unix). Then early days
              of web (all things) and Linux (90's). My background is Unix/Linux/Virtualization (RHEL, Docker, VMWare, KVM). So, building web sites is a hobby and love (working with code).
              I don't do web development for a living (wish I was good enough to do so). See the link 'Technical' on the main page, and the site <a href="https://docs.tkwebdev23.com" target="_blank" style="text-decoration: none; color: blue;">docs.tkwebdev23.com</a> for more details.
              These two (Vue.js and Vuetify) are the main web development technolgies used by <a href="https://www.tkwebdev23.com" target="_blank" style="text-decoration: none; color: blue;">www.tkwebdev23.com</a> for web development (the parent of www.timmyskittys.com & docs.tkwebdev23.com)
              which is also still in development.
              <br>
              <br>
              <b>Web Developers Take Note:</b> Timmy's Kitty's is in its beginning stages. If any one has web development experience (HTML, CSS, JavaScript), and may be interested in helping design and develop Timmy's Kitty's further,
              take it to the next level, bring it into the future, email us at <a href="mailto:tkwebdev23@gmail.com" style="text-decoration: none; color: blue;">tkwebdev23@gmail.com</a> . We'll be happy to discuss and explore posibilities.
              </p>

              <br>
              <p class="pl-2 pb-2"><span class="firstletter">T</span>hird, I know I may have more animals than the average human. So, no better way to show off my family of animals than to build a web site. I'm proud of each and everyone of them, even the kittys we foster, rescue, and raise from birth for adoption (usually from a rescued pregnant female, ferel or not). And, the biggest reward is when each animal finds their loving permanent forever home.</p>

            </p>
          </v-card>
        </v-flex>

        <!-- Notes on/about Timmy's Kitty's -->
        <v-flex xs12 sm8>
          <v-card flat class="v-card-border mb-2">
            <p style="font-size: 1.3rem;">
              <v-icon class="profilebio pl-2 pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
              Timmy's Kitty's Notes:
            </p>
            <p class="pl-3">
              <v-icon class="profilebio pl-2 pb-1" size=".8rem" color="blue">fas fa-square</v-icon>
              <span style="font-size: 1rem;">Note One:</span>
              <p class="pl-5">www.timmyskittys.com is still in development.</p>
            </p>
            <p class="pl-3">
              <v-icon class="profilebio pl-2 pb-1" size=".8rem" color="blue">fas fa-square</v-icon>
              <span style="font-size: 1rem;">Note Two (more a disclaimer):</span>
              <p class="pl-5 pb-2"><span class="firstletter">T</span>he main focus of this web site is not on showcasing amazing pictures, videos, and graphics (although I do try my best). So, needless to say, some the photos
              aren't the best quility (poor lighting, somewhat blurry/fuzzy, washed out). I did my best to fix using Gimp. In time, I hope to replace the poor quality photos with better
              quality photos (using my Canon Rebel 1 camera instead of an iPhone). Continues Improvement!
              <br>
              <br>
              Along the same lines, I don't claim to be a writer or author, in any fashion of the word and/or meaning. Along with the technical stuff, I do spend a considerable amount of time
              trying to write the best insite into each animal, and to help bring something to the vistor in forming a connection and bond. Also, with the bio writings for each cat,
              they are not necessarily meant to be a full written story with sentences that nicely flow from one to the other. So, it may appear fragmented and or chop off in mid-story telling.
              This is a direct result of my attempt to avoid an excessively long bio section for the writings, and meant more for bits and pieces of details for the topics, such as, 'likes', 'disklikes', 'personality', 'who am i', and so on.
              I'm always open to constructive, detailed, and meaningful input/advice/corrections/insite/direction/etc..., please email us at <a href="mailto:tkwebdev23@gmail.com" style="text-decoration: none; color: blue;">tkwebdev23@gmail.com</a> .
              </p>
            </p>
            <p class="pl-3">
              <v-icon class="profilebio pl-2 pb-1" size=".8rem" color="blue">fas fa-square</v-icon>
              <span style="font-size: 1rem;">Note Three:</span>
              <p class="pl-5 pb-2"><span class="firstletter">I</span> understand animals can't speak and write human languages, nor have ambitions, favorite movies, music, etc...
              To give each animal an identity that I felt best matched their personality (who this animal really is), and to provide that indepth
              look into the animal, at times it fits the occasion (if you will). Besides, at Timmy's Kitty's you're supposed have some imagination,
              I hope. I belive this is important if I want to build a site that will give a more personal connection to an animal for any potential
              adoptor. We place animals in the right home, not just any home.
              </p>
            </p>
          </v-card>
        </v-flex>

        <!-- Current Issues users should be aware of on/about Timmy's Kitty's -->
        <v-flex xs12 sm8>
          <v-card flat class="v-card-border mb-2" elevation-24>
            <p style="font-size: 1.3rem;">
              <v-icon class="profilebio pl-2 pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
              Timmy's Kitty's Issues to Be Aware Of:
            </p>
            <p class="pl-3">
              <v-icon class="profilebio pl-2 pb-1" size=".8rem" color="blue">fas fa-square</v-icon>
              <span style="font-size: 1.2rem;">Issue One:</span>
              <p class="pl-5 pb-2">
                <b>-Issues:</b><br>
                &nbsp;&nbsp;&nbsp;&nbsp;*The pictures can be off center on some screens.<br>
                &nbsp;&nbsp;&nbsp;&nbsp;*The Initial in the upper left corner of each cats profile is off center in Edge browsers.<br>
                &nbsp;&nbsp;&nbsp;&nbsp;*On some screens the text and links on the cards go of the the card (for the page where the cards for all the cats are listed (tkbios)).<br>
                <!-- <br> -->
                <!-- <br> -->
                <!-- <b>-Technically Speaking:</b> -->
                <br>
                <b>-Status:</b><br>
                &nbsp;&nbsp;&nbsp;&nbsp;*Still troubleshootin the above issues..<br>
              </p>
            </p>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Back to top button. Show on mobile/ipad only -->
    <div class="hidden-md-and-up">
      <v-btn
        id="scrolltotop"
        bottom fab fixed right small dark elevation-24
        color="transparent"
        class="back-to-top"
        style="color: blue;"
        slot="activator"
        v-on:click="scrollToTop"
      ><v-icon medium>keyboard_arrow_up</v-icon>
      </v-btn>
    </div>

    <v-container>
      <v-layout class="footer">
        <footer-view></footer-view>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import TkHeaderView from "./TkHeaderView";
import FooterView from "./FooterView";


export default {
  components: {
    TkHeaderView,
    FooterView
  },
  data: () => ({}),
  methods: {
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth"
      });
    },
    handleScroll () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("scrolltotop").style.display = "block";
      } else {
        document.getElementById("scrolltotop").style.display = "none";
      }
      this.scrolled = window.scrollY > 0;
    }
  },
  computed: {
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
};
</script>

<style scoped>
.main {
  /* background-image: url("../img/white_wrinkled_silk_blue_1440x1190.jpg"); */
  background-color: #f8f8ff;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.link-style {
  text-decoration: none;
  list-style-type: none;
  color: #00f;
}
.mainheading {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2rem;
  font-weight: bolder;
  color: blue;
  background-color: #f8f8ff;
}
.tkheading {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 1.6rem;
  line-height: 0;
  font-weight: bolder;
  color: blue;
  margin-right: 3px;
}
.firstletter {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2rem;
  line-height: 0;
  font-weight: bolder;
  color: blue;
  margin-right: 3px;
}
.tklogo {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2rem;
  font-weight: bold;
 }
.v-card-border {
  border: 2px solid rgba(0, 0, 0, .1);
}
.footer {
  margin-top: 20px;
}
/******** iPads (portrait) *********/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .footer {
    margin-top: 20px;
  }
}
/********** iPad 3 (landscape) **********/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .footer {
    margin-top: 20px;
  }
}
/************ iPad Pro (portrait) ***********/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  .footer {
    margin-top: 0px;
  }
}
/************ iPad Pro (landscape) ***********/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .footer {
    margin-top: 0px;
  }
}
/************************************** iPhones *************************************/
@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 20px;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 70px;
  }
}
/* iPhone X ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 20px;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 70px;
  }
}
/* iPhone 6/7/8/X plus ----------- */
@media only screen and (min-device-width: 414px) and (max-device-height: 896px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 20px;
  }
}
@media only screen and (min-device-width: 414px) and (max-device-height: 896px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 70px;
  }
}
/* Samsung Galaxy S5 ----------- */
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 20px;
  }
}
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 70px;
  }
}
/* Samsung Galaxy III */
@media screen and (device-width: 360px) and (device-height: 640px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
}
/* Nexus */
@media screen and (device-width: 600px) and (device-height: 960px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
}
/* Amazon Fire HD 8.9 */
@media only screen  and (min-device-width: 1200px) and (max-device-width: 1920px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
}
@media only screen and (min-device-width: 800px) and (max-device-width: 1280px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TkAboutView.vue